import type { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { stopEventRefs } from "../subjects/stopEvent/refs";
import { callRejectionFacts, callRejectionV2Facts } from "../subjects/stopEvent/callRejectionFacts";

/**
 * The TMS refused to dispatch the load because it would exceed a limit, such as the deadhead allowance.
 */
export const dispatchLimitExceededV1 = tmsEventKind(
  { category: "callRejection", kind: "dispatchLimitExceeded", version: 1 },
  { refs: stopEventRefs, facts: callRejectionFacts },
);

export const DispatchLimitExceededV1Schema = dispatchLimitExceededV1.schema;
export const DispatchLimitExceededV1FactsSchema = dispatchLimitExceededV1.facts;

export type DispatchLimitExceededV1 = z.infer<typeof DispatchLimitExceededV1Schema>;
export type DispatchLimitExceededV1Facts = z.infer<typeof DispatchLimitExceededV1FactsSchema>;

/**
 * Version 2: the same refusal, plus what the driver's call said — its type, load, trailers, consignee, and lines.
 */
export const dispatchLimitExceededV2 = tmsEventKind(
  { category: "callRejection", kind: "dispatchLimitExceeded", version: 2 },
  { refs: stopEventRefs, facts: callRejectionV2Facts },
);

export const DispatchLimitExceededV2Schema = dispatchLimitExceededV2.schema;
export const DispatchLimitExceededV2FactsSchema = dispatchLimitExceededV2.facts;

export type DispatchLimitExceededV2 = z.infer<typeof DispatchLimitExceededV2Schema>;
export type DispatchLimitExceededV2Facts = z.infer<typeof DispatchLimitExceededV2FactsSchema>;

/** Every version of `dispatchLimitExceeded`, keyed by version. What `catalog.ts` places under `callRejection`. */
export const dispatchLimitExceeded = { 1: dispatchLimitExceededV1, 2: dispatchLimitExceededV2 } as const;
